// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"4998":"css/app-components","6170":"css/app","6667":"css/app-base","7998":"css/app-utilities"}[chunkId] + ".css";
};